import { FC, ReactNode } from 'react'
import { IconLink } from 'icons'
import SectionHeader from 'components/SectionHeader'
import Typography from 'components/Typography'
import styles from './About.module.scss'
import Anchor from 'components/Anchor'

export type TProps = {
  title: string
  paragraphs?: Array<string>
  footer?: ReactNode
  showMore?: {
    text: string
    href: string
  }
}

const About: FC<TProps> = ({ title, paragraphs, footer, showMore }) => {
  return (
    <div className={styles.ecPageRegionSection}>
      <SectionHeader
        title={{
          value: title,
        }}
      />
      {(footer || paragraphs) && (
        <div className={styles.ecRegionAboutContainer}>
          {paragraphs && (
            <div className={styles.ecRegionAboutTextContainer}>
              {paragraphs.map((text) => (
                <Typography
                  key={text}
                  className={styles.ecRegionAboutParagraph}
                >
                  {text}
                </Typography>
              ))}
            </div>
          )}
          {footer}
        </div>
      )}
      {showMore && (
        <Anchor
          href={showMore.href}
          Icon={{
            Component: IconLink,
            title: 'Ícone: link',
          }}
          data-testid="ecFeatureAnchor"
        >
          {showMore.text}
        </Anchor>
      )}
    </div>
  )
}

export default About
